<template>
  <div>
    <v-btn color="yellow" class="" icon @click="dialog = true"
      ><v-icon>mdi-pencil</v-icon></v-btn
    >
    <v-dialog v-model="dialog" persistent width="500">
      <v-card>
        <v-card-title>Edit Chart of Account</v-card-title>
        <v-card-text>
          <v-text-field
            label="Account Code"
            v-model="item.account_code"
          ></v-text-field>
          <v-text-field
            label="Account Title"
            v-model="item.account_title"
          ></v-text-field>
          <v-text-field label="Remarks" v-model="item.remarks"></v-text-field>
          <v-select
            label="Notes to FS"
            v-model="item.notes_to_fs"
            :items="notes_to_fs"
          ></v-select>
          <v-select
            label="Sub Type"
            :items="sub_types"
            v-model="item.sub_type"
          ></v-select>
          <v-select
            label="Normal Balance"
            :items="['debit', 'credit']"
            v-model="item.normal_balance"
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="submit" :loading="loading"
            >Submit</v-btn
          >
          <v-btn @click="dialog = false"> Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["item"],
  data() {
    return {
      notes_to_fs: [
        "Drawings",
        "Expenses",
        "Assets",
        "Non-current Assets",
        "Liabilities",
        "Non-current Liabilities",
        "Equity",
        "Revenue",
        "Contra Revenue",
        "Cost of Goods Sold",
      ],
      sub_types: [
        "Cash and Cash Equivalents",
        "Current Asset",
        "Non-current Asset",
        "Current Liability",
        "Non-current Liability",
        "Operating Expense",
        "Non-operating Expense",
        "Operating Revenue",
        "Non-operating Revenue",
        "Cost of Goods Sold",
        "Direct Expense",
        "Indirect Expense",
        "Other Expense",
        "Other Revenue",
        "Owner's Equity",
        "Owner's Drawings",
        "Retained Earnings",
      ],
      dialog: false,
      loading: false,
    };
  },
  methods: {
    ...mapActions({
      edit_chart_of_account: "chart_of_account/edit_chart_of_account",
    }),

    submit() {
      this.loading = true;
      let x = window.confirm("Are you sure you want to add this entry?");
      if (x) {
        this.edit_chart_of_account(this.item).then(() => {
          alert("Successfully edited a chart of account");
          this.loading = false;
        });
      } else {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
